app.service('subscriptionInvoices', function (pageConfig) {

	let $self, $invoicesWrapper;

	function init() {
		setElements();
		loadInvoices();
	}

	function setElements() {
		$self = $('#customer-subscription-invoices');
		$invoicesWrapper = $self.find('#subscription-invoices');
	}

	function loadInvoices() {

		fetchSubscriptionInvoices()
			.then(render)
			.fail(() => {
				onError();
			})
			.always(() => {
				$invoicesWrapper.removeClass('loading');
			});
	}

	function fetchSubscriptionInvoices() {

		const {initialOrderId} = pageConfig.getData('account');

		return $.ajax({
			url: '/customer-subscription-invoices.ltr',
			data: {
				initialOrderId
			}
		});
	}

	function render(html) {
		$invoicesWrapper.html(html);
	}

	function onError(message = "Błąd ładowania listy faktur.") {
		$invoicesWrapper.html(`<div class="error-message">${message}</div>`);
	}

	return {
		init
	};
});